import React from 'react';
import cn from 'classnames';

import Layout from '../../components/layout/Layout';
// import Link from '../../components/common/ui/Link';
import FaqItem from '../../components/faq/FaqItem';
import BoxIcon from '../../assets/icons/faq/BoxIcon';
import HeadphoneIcon from '../../assets/icons/faq/HeadphoneIcon';
import PowerIcon from '../../assets/icons/faq/PowerIcon';
import UserIcon from '../../assets/icons/faq/UserIcon';
import NoteIcon from '../../assets/icons/faq/NoteIcon';
import ChatIcon from '../../assets/icons/faq/ChatIcon';
import { openGladlyChat } from '../../utils/gladly';
import { CONTACT_US_JOTFORM } from '../../constants/links';

import styles from './styles.module.scss';

const faqItems = [
  {
    text: 'Get Started',
    img: PowerIcon,
    link: 'https://homefi.info/pages/support?category=get-started',
  },
  {
    text: 'Plan & Data Management',
    img: BoxIcon,
    link: 'https://homefi.info/pages/support?category=account-management&subcategory1=billing-payments',
  },
  {
    text: 'Account Management',
    img: UserIcon,
    link: 'https://homefi.info/pages/support?category=account-management',
  },
  {
    text: 'Technical Support',
    img: HeadphoneIcon,
    link: 'https://homefi.info/pages/support?category=technical-support',
  },
  {
    text: 'What’s new',
    img: NoteIcon,
    link: 'https://homefi.info/pages/support?category=what-s-new',
  },
];

const Support = () => {
  const helpCenterLink = 'https://homefi.info/pages/support';
  return (
    <Layout>
      <div className={styles.faq}>
        <h1 className={cn('h1', styles.faqTitle)}>Support</h1>
        <div className={styles.faqWrapper}>
          <div>
            <p className={styles.faqDesc}>
              Visit our{' '}
              <a
                href={helpCenterLink}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.faqHelpCenter}
              >
                Help Center
              </a>{' '}
              for Frequently Asked Questions with these categories:
            </p>
            <ul className={styles.faqList}>
              {faqItems.map((faqItem, index) => (
                <FaqItem key={index} faqData={faqItem}></FaqItem>
              ))}
            </ul>
          </div>
          <div className={styles.faqWidgets}>
            <button onClick={openGladlyChat} className={styles.faqWidget}>
              <div className={styles.faqWidgetContent}>
                <h3 className="h3">Chat with us</h3>
                <p className="text">
                  Chat to ask questions or resolve any issues
                </p>
              </div>
              <div className={styles.faqWidgetIcon}>
                <ChatIcon></ChatIcon>
              </div>
            </button>
            <a
              href={CONTACT_US_JOTFORM}
              className={cn(styles.faqWidget, styles.faqContactWidget)}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={styles.faqWidgetContent}>
                <h3 className="h3">Contact Us Form</h3>
                <p className="text">
                  Save time by submitting a request through our Contact Form.
                  Our team will address your inquiry within 24-48 hours.
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Support;
